import { IconProps } from "../../utils/global-types/global-types";

const InfoFilledIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 11 11"
    className={className ? className : "w-[11px] h-[11px]"}
    {...rest}
  >
    <g clipPath="url(#clip0_info_filled)">
      <path
        d="M5.33208 10.3997C2.46545 10.3883 0.18765 8.04087 0.270759 5.18119C0.350146 2.44902 2.58714 0.247378 5.37252 0.266728C8.17775 0.286327 10.4254 2.57827 10.3976 5.3742C10.3698 8.16157 8.08534 10.428 5.33208 10.3997ZM5.4395 4.61208C4.92609 4.62895 4.46701 4.8067 4.04315 5.08691C4.0073 5.11061 3.97294 5.13988 3.94578 5.173C3.84903 5.29109 3.88214 5.39107 4.02802 5.42915C4.08409 5.44379 4.14164 5.45383 4.19672 5.47145C4.42967 5.54575 4.49244 5.65999 4.43339 5.9015C4.28975 6.4886 4.14326 7.07507 4.00209 7.66279C3.8974 8.09893 4.11832 8.45555 4.53697 8.48792C5.15656 8.53568 5.70955 8.33126 6.20696 7.97228C6.25968 7.93432 6.30049 7.8398 6.2949 7.77604C6.29156 7.73734 6.18947 7.70546 6.12968 7.67445C6.1045 7.66142 6.07398 7.65894 6.04595 7.65138C5.76884 7.57732 5.69677 7.46147 5.76388 7.18498C5.9028 6.61165 6.05054 6.04043 6.18029 5.465C6.21105 5.3288 6.21316 5.17226 6.17868 5.03792C6.1014 4.73873 5.83954 4.60042 5.4395 4.61208ZM6.72856 2.856C6.7293 2.32683 6.32033 1.9093 5.79774 1.90583C5.26634 1.90223 4.83963 2.32472 4.8441 2.8498C4.84856 3.37314 5.26448 3.78397 5.79179 3.7857C6.30594 3.78744 6.72769 3.36879 6.72856 2.856Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_info_filled">
        <rect width="10.6667" height="10.6667" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default InfoFilledIcon;
